import React from 'react';
import {
  FDPaper, FDPrimaryActionButton, FDStack, FDTitleText,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import {
  IncomeInformationTable,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeInformation/IncomeInformationTable';
import PropTypes from 'prop-types';
import Resource from 'facet-rest/src/domain/Resource';

const IncomeInformationSection = ({
  clientIncomeInformationResource,
  handleAddIncomeRelationship,
  onEditIncome,
  onDeleteIncome,
}) => {
  return (
    <FDPaper
      width={'100%'}
      padding={4}
    >
      <FDStack direction={'column'} spacing={2}>
        <FDStack
          direction={'row'}
          spacing={2}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <FDTitleText
            size={'lg'}
            color={'textSecondary'}
            value={clientIncomeInformationResource.attr('name')}
            maxLines={2}
          />
          {handleAddIncomeRelationship && clientIncomeInformationResource.withRelationship(
            fr.relationships.addIncome.name,
            (rel) => (
              <FDPrimaryActionButton
                icon={'add'}
                label={rel.meta('prompt')}
                size={'sm'}
                disabled={!handleAddIncomeRelationship}
                onClick={() => handleAddIncomeRelationship(rel.link('related'))}
                flexShrink={0}
              />
            ),
            () => null,
          )}
        </FDStack>
        <IncomeInformationTable
          incomeSummaryCollection={clientIncomeInformationResource.attr('incomeSummaries')}
          onEditIncome={onEditIncome}
          onDeleteIncome={onDeleteIncome}
        />
      </FDStack>
    </FDPaper>
  );
};

IncomeInformationSection.defaultProps = {
  handleAddIncomeRelationship: undefined,
  onEditIncome: undefined,
  onDeleteIncome: undefined,
};

IncomeInformationSection.propTypes = {
  clientIncomeInformationResource: PropTypes.instanceOf(Resource).isRequired,
  handleAddIncomeRelationship: PropTypes.func,
  onEditIncome: PropTypes.func,
  onDeleteIncome: PropTypes.func,
};

export { IncomeInformationSection };
